import React from 'react';

import { CssBaseline, ThemeProvider } from '@mui/material';

import useThemeModePreference, { THEME_MODES } from '~/hooks/useThemeModePreference';

import { darkTheme, lightTheme } from '../configs/leTheme';

export default function MUIProvider({ children }) {
  const { themeMode } = useThemeModePreference();
  const theme = themeMode === THEME_MODES.DARK ? darkTheme : lightTheme;

  // Keep this nested provider while pages migrate: the root app theme handles legacy MUI,
  // and this provider applies the newer LE design-system theme to opted-in pages.
  // CssBaseline is repeated intentionally so leTheme's global overrides win on those pages.
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>{children}</CssBaseline>
    </ThemeProvider>
  );
}
